import { SVSummaryCardItem } from '@/types/common';
import { buildAddress } from '@/utils/address';
import { titleCase } from '@/utils/stringCaser';
import {
  RecipientDetail,
  RecipientRequestDetail,
} from '@/types/wireRecipients';
import { SVHiddenText, SVSummaryCard } from '@/components/core';

type WireRecipientDetailsBankInfoProps = {
  bankInfo: RecipientDetail | RecipientRequestDetail;
};

export default function WireRecipientDetailsBankInfo({
  bankInfo,
}: WireRecipientDetailsBankInfoProps) {
  const {
    bankName,
    accountNumber,
    routingNumber,
    accountType,
    bankAddressCity,
    bankAddressCountryCode,
    bankAddressLine1,
    bankAddressLine2,
    bankAddressPostalCode,
    bankAddressState,
  } = bankInfo;

  const items: SVSummaryCardItem[] = [
    {
      label: 'Bank Name',
      text: bankName,
    },
    {
      label: 'Account Type',
      text: titleCase(accountType),
    },
    {
      label: 'Account Number',
      customContent: (
        <SVHiddenText
          text={accountNumber}
          ariaLabel="Account Number"
          visibleCount={4}
        />
      ),
    },
    {
      label: 'Routing Number',
      customContent: (
        <SVHiddenText
          text={routingNumber}
          ariaLabel="Routing Number"
          visibleCount={4}
        />
      ),
    },
    {
      label: 'Address Associated with the Account',
      text: buildAddress({
        line1: bankAddressLine1,
        line2: bankAddressLine2,
        city: bankAddressCity,
        country: bankAddressCountryCode,
        postalCode: bankAddressPostalCode,
        state: bankAddressState || '',
      }),
    },
  ];

  return <SVSummaryCard label="Bank Info" items={items} />;
}
